<template>
  <aside class="project-one-right-rail" qaid="project-one-right-rail">
    <project-one-right-rail-header
      :base-properties="baseProperties"
      :group-id="groupId"
      :is-back-button-enabled="true"
      @on-backpress="returnToPreviousRailView"
    />

    <section class="project-one-right-rail__body" qaid="project-one-right-rail-body">
      <div qaid="project-one-right-rail-option" class="project-one-right-rail-option">
        <responsive-image
          v-if="imageReference"
          slot="image"
          qaid="project-one-right-rail-option-img"
          class="project-one-right-rail-option__img"
          :src="imageReference"
          sizes="(max-width: 768) 100vw, (max-width: 1024) 50vw, 20vw"
          aspect-ratio="4x3"
        />
        <h4
          v-if="contentData && contentData.description"
          qaid="project-one-right-rail-option-title"
          class="project-one-right-rail-option__title"
          v-html="contentData.description"
        />
        <p v-if="isHidingPrices" qaid="project-one-right-rail-option-price" v-html="bp('priceVaries')" />
        <p
          v-else-if="contentData && contentData.priceDifferenceDealerCost && b2b && !consumerFriendlyMode"
          qaid="project-one-right-rail-option-price"
          class="project-one-right-rail-option__price"
          v-html="contentData.priceDifferenceDealerCost"
        />
        <p
          v-else-if="contentData && contentData.priceDifferenceAdvertised"
          qaid="project-one-right-rail-option-price"
          class="project-one-right-rail-option__price"
          v-html="contentData.priceDifferenceAdvertised"
        />
        <p
          v-if="contentData && contentData.marketingCopy"
          qaid="project-one-right-rail-option-description"
          class="project-one-right-rail-option__description"
          v-html="contentData.marketingCopy"
        />
      </div>
    </section>

    <project-one-right-rail-footer
      :base-properties="baseProperties"
      :button-action="changeSelection"
      button-icon="add_circle_outline"
      :button-icon-left="true"
      :button-secondary="true"
      :button-text="bp('addBike')"
    />
  </aside>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import ProjectOneRightRailFooter from '@/projectOne/components/rightRail/components/ProjectOneRightRailFooter';
import ProjectOneRightRailHeader from '@/projectOne/components/rightRail/components/ProjectOneRightRailHeader';
import ResponsiveImage from '@/components/ResponsiveImage';

export default {
  components: {ProjectOneRightRailFooter, ProjectOneRightRailHeader, ResponsiveImage},

  computed: {
    contentData() {
      const moduleGroup = this.moduleGroups.find((group) => group.id === this.groupId);
      return moduleGroup.choices.find((choice) => choice.id === this.activeRailData.content.choiceId);
    },

    groupId() {
      return this.activeRailData?.content?.groupId;
    },

    topTierPackageId() {
      const moduleGroup = this.moduleGroups.find((group) => group.id === this.activeRailData.content.groupId);
      return moduleGroup.topTierPackageId;
    },

    imageReference() {
      if (this.contentData?.imageThumbnailReference) {
        return `${this.baseImageUrl}${this.contentData?.imageThumbnailReference}?fit=crop`;
      }

      return null;
    },

    ...mapGetters('projectOne', ['activeRailData']),
    ...mapState('projectOne', ['baseImageUrl', 'currentRoute', 'moduleGroups', 'railDataStack', 'isHidingPrices']),
    ...mapState('backend', ['b2b', 'consumerFriendlyMode']),
  },

  methods: {
    changeSelection() {
      this.$notify({
        type: 'success',
        message: this.bp('added'),
      });

      this.updateSelection({
        selections: [
          {
            groupId: this.groupId,
            choiceId: this.activeRailData?.content?.choiceId,
            topTierPackageId: this.topTierPackageId,
          },
        ],
        buildId: this.$route.params.buildId,
        module: this.currentRoute,
        bpData: this.bpData,
      });

      this.returnToInitialRailView();
    },

    returnToInitialRailView() {
      while (this.railDataStack?.length > 1) {
        this.popRailDataStack();
      }
    },

    returnToPreviousRailView() {
      if (this.railDataStack?.length > 1) {
        this.popRailDataStack();
      } else {
        this.$emit('on-backpress');
      }
    },

    ...mapActions('projectOne', ['updateSelection']),
    ...mapMutations('projectOne', ['popRailDataStack']),
  },
};
</script>

<style lang="scss" scoped>
.project-one-right-rail-option {
  @apply mb-4;
  @apply max-w-sm;
  @apply mx-auto;

  @include breakpoint(large) {
    @apply max-w-none;
  }

  &__img {
    @apply w-full;
    @apply mb-3;
  }

  &__title {
    @apply mb-1;
    @apply text-lg;
  }

  &__price {
    @apply text-blue;
    @apply text-sm;
  }

  &__description {
    @apply mt-2;
    @apply text-gray-60;
    @apply text-sm;
    @apply leading-normal;
  }
}
</style>
